import type { FeatureManifest } from '../registry.js';

/** SY-02 settings (SCR-18): sound, language, accessibility, account, privacy, parental, delete account. */
export default {
  id: 'settings',
  provides: ['settings', 'deleteAccount'],
  load: () => import('./index.js'),
} satisfies FeatureManifest;
